export default __webpack_public_path__ + "static/media/eco-therapy.3b52e6af.svg";